<template>
  <div class="ckbox ckbox-primary">
    <input
      :id="id"
      ref="input"
      type="checkbox"
      :checked="checked === valueTrue"
      :disabled="disabled"
      v-model="model"
      :name="name"
      :readonly="readonly"
      :true-value="valueTrue"
      :false-value="valueFalse"
    />
    <label :for="id">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "checkbox",
  props: {
    name: String,
    disabled: Boolean,
    readonly: Boolean,
    checked: [Number, Array, Boolean],
    valueTrue: {
      type: [Number, Boolean],
      default: true
    },
    valueFalse: {
      type: [Number, Boolean],
      default: false
    }
  },
  data() {
    return {
      id: null
    };
  },
  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        this.$emit("input", check);
      }
    }
  },
  created() {
    this.id = Math.random()
      .toString(16)
      .slice(2);
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/Checkbox.vue